import React, { useState } from 'react';
import { Box, Typography, SxProps, Theme } from '@mui/material';

interface HoverShortcutProps {
    defaultContent: React.ReactNode;
    hoverContent: React.ReactNode;
    onClick: (e: React.MouseEvent) => void;
    fontSize: number;
    defaultColor?: string;
    forceHovered?: boolean;
    sx?: SxProps<Theme>;
}

export default function HoverShortcut({
    defaultContent,
    hoverContent,
    onClick,
    fontSize,
    defaultColor = '#919EAB',
    forceHovered,
    sx,
}: HoverShortcutProps) {
    const [hovered, setHovered] = useState(false);
    const isHovered = forceHovered ?? hovered;

    return (
        <Box
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                ...sx,
            }}
        >
            {isHovered ? (
                <Typography
                    variant="body2"
                    onClick={(e) => {
                        e.stopPropagation();
                        onClick(e);
                    }}
                    sx={{
                        fontWeight: 500,
                        fontSize,
                        color: '#006C9C',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        lineHeight: '22px',
                        '&:hover': {
                            textDecoration: 'underline',
                        },
                    }}
                >
                    {hoverContent}
                </Typography>
            ) : (
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        fontSize,
                        color: defaultColor,
                        whiteSpace: 'nowrap',
                        lineHeight: '22px',
                    }}
                >
                    {defaultContent}
                </Typography>
            )}
        </Box>
    );
}